<div [formGroup]="form">
  <div class="section-container" id="dados-adicionais">
    <div class="section-title">
      <mat-icon>notes</mat-icon>
      <span>Dados Adicionais</span>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Observações</mat-label>
          <textarea matInput formControlName="observacaoInterna" rows="3"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-select-pesquisavel label="Tags" [offlineList]="listaTags" [control]="$any(form.get('tags'))"
          idField="id" nameField="descricao" [corField]="'cor'" [multiple]="true" [showBadges]="true"
          placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>
    </div>
  </div>
</div>
